var _desc, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "41px",
    height: "41px",
    viewBox: "0 0 41 41",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Lunacy")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 20.5C0 9.1754 9.1754 0 20.5 0C31.8246 0 41 9.1754 41 20.5C41 31.8246 31.8246 41 20.5 41C9.1754 41 0 31.8246 0 20.5ZM20.5 37.0323C11.366 37.0323 3.96777 29.6341 3.96777 20.5C3.96777 11.366 11.366 3.96777 20.5 3.96777C29.6341 3.96777 37.0323 11.366 37.0323 20.5C37.0323 29.6341 29.6341 37.0323 20.5 37.0323ZM18.5906 23.3023L25.6085 28.4025C26.0549 28.7249 26.6749 28.6257 26.9972 28.1876L28.5513 26.0466C28.8736 25.6003 28.7827 24.9803 28.3364 24.6579L22.8146 20.6406L22.8146 8.92748C22.8146 8.38192 22.3682 7.93555 21.8226 7.93555L19.1775 7.93555C18.6319 7.93555 18.1855 8.38192 18.1855 8.92748L18.1855 22.5005C18.1855 22.8146 18.3343 23.1122 18.5906 23.3023Z",
    id: "Shape",
    fill: "#0080FF",
    fillRule: "evenodd",
    stroke: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.91f21afd44637a9bcc60d927ea83e9bd.svg";
export { ForwardRef as ReactComponent };